import React from 'react';
import {
  useBreakpoint,
  Pagination,
  PaginationDisplayedItemCount
} from '@one-thd/sui-atomic-components';
import { PAGE_SIZE } from '../../utils/consts';
import { updateUrlParam } from '../../utils/general';

interface IGCPaginationProps {
  totalPages: number;
  totalGiftCards: number;
  pageNumber: number;
  onPageChange: (pageNumber: number) => void;
}

export const GiftCardPagination: React.FC<IGCPaginationProps> = ({
  totalPages,
  totalGiftCards,
  pageNumber,
  onPageChange
}) => {
  const matches = useBreakpoint('sm');

  const handlePageChange = (event: React.ChangeEvent<HTMLInputElement>, value: number) => {
    event.preventDefault();
    const pageUrlParam = value > 1 ? value.toString() : null;
    updateUrlParam([{ key: 'page', newValue: pageUrlParam }]);
    onPageChange(value);
  };

  return (
    <div className="sui-flex sui-flex-col sui-items-center">
      <Pagination
        count={totalPages}
        page={pageNumber}
        onChange={handlePageChange}
        siblingCount={matches.lesser ? 0 : 1}
      />
      <PaginationDisplayedItemCount
        page={pageNumber}
        itemsPerPage={PAGE_SIZE}
        items={totalGiftCards}
      />
    </div>
  );
};
